(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('CustomActivitySearch', CustomActivitySearch);

    CustomActivitySearch.$inject = ['$resource'];

    function CustomActivitySearch($resource) {
        var resourceUrl =  'api/_search/custom-activities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
